import { Component, Input, SimpleChanges } from '@angular/core';
import { INomOrgProjectDetail } from '../shared/models/nom-org-project-detail';
import { ITableColumn, TableColumnType } from '../../controls/table/table-column';
import { ProjectService } from '../../projects/shared/services/project.service';


@Component({
    selector: 'app-nom-org-project',
    templateUrl: './nom-org-project.component.html',
    styleUrl: './nom-org-project.component.scss',
    standalone: false
})
export class NomOrgProjectComponent {
  @Input() committees: string[] = [];
  projectDetails: INomOrgProjectDetail[] = [];
  tableData: INomOrgProjectDetail[] = [];
  tableColumns: ITableColumn<INomOrgProjectDetail>[] = [];
  loading: boolean = true;

  constructor(private _projectService: ProjectService) {}

  ngOnInit(): void {
    if(this.committees && this.committees.length > 0) {
      this.initialize();
    } else {
      this.tableData = [];
      this.initializeTableColumns();
      this.loading = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['committees'] && !changes['committees'].firstChange) {
      if(this.committees && this.committees.length > 0) {
        this.loading = true;
        this.initialize();
      } else {
        this.tableData = [];
        this.initializeTableColumns();
        this.loading = false;
      }
    }
  }

  initialize() {
    this._projectService.getProjectsByCommittees(this.committees).subscribe({
      next: (response) => {
        this.projectDetails = response.content;
        if (this.projectDetails && this.projectDetails.length > 0) {
          this.initializeTableData();
          this.initializeTableColumns();
          this.loading = false;
        }else {
          this.tableData = [];
          this.loading = false;
        }
      },
      error: (err) => {
        console.error('Error fetching projects:', err);
      },
    });
  }

  initializeTableData() {
    this.tableData = this.projectDetails;
  }

  initializeTableColumns() {
    let columns: ITableColumn<INomOrgProjectDetail>[] = [
      {
        name: 'designation',
        displayName: 'Designation',
        type: TableColumnType.routerLink,
        isSortable: true,
        getLink: (row: INomOrgProjectDetail) => `/projects/${row.projectId}`,
        headerWidth: '250px',
      },
      {
        name: 'committee',
        displayName: 'Committee Code',
        type: TableColumnType.routerLink,
        isSortable: true,
        getLink: (row: INomOrgProjectDetail) => `/committees/${row.committee}`,
        headerWidth: '15%',
      },
      {
        name: 'phase',
        displayName: 'Phase',
        isSortable: true,
      },
      {
        name: 'phaseStart',
        displayName: 'Phase Start',
        type: TableColumnType.date,
        isSortable: true,
      },
      {
        name: 'phaseEnd',
        displayName: 'Phase End',
        type: TableColumnType.date,
        isSortable: true,
      },
      {
        name: 'status',
        displayName: 'Status',
        isSortable: true,
      },
    ];

    this.tableColumns = columns;
  }
}
